import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M4 22H2V2H4V22ZM15 21H5V18H15V21ZM18 16H5V13H18V16ZM21 11H5V8H21V11ZM13 6H5V3H13V6Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "BarChartHorizontal"
);
